import { toReset } from 'react-async-client';
import { GET_WORKSHEET_MASS_LIST } from 'constants/actionTypes';

export default (state, action, defaultReducer) => {
    switch (action.type) {
        case toReset(GET_WORKSHEET_MASS_LIST):
            return defaultReducer(undefined, {});
        default:
            return defaultReducer(state, action);
    }
}
